<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Vídeos</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="videos">Vídeos</label>
                                    <select name="videos[]" id="videos" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(video, index) in videos">
                                            {{ video.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setVideos">Ordenar Vídeos <i
                                        class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(video,index) in selected' :key="video.id"
                                        class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left"></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="stages" :id="'stage' + video.id">{{ index + 1 }}. {{ video.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(video, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar
                                </button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação
                                    <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default {
        data: function () {
            return {
                videos: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getVideosArray: function (data) {
                let array = [];
                $.each(data, function (index, value) {
                    if (value.sort_by) {
                        array.push(index);
                    }
                });
                return array;
            },
            getVideos: function () {
                let self = this;
                let api = self.$store.state.api + 'video?paginated=false';
                let videos = $('#videos');

                self.$http.get(api)
                    .then((response) => {
                        self.videos = response.data.data;
                        self.ordered = self.getVideosArray(self.videos);
                    })
                    .then(() => {
                        videos.bootstrapDualListbox();
                        videos.ready(function () {
                            videos.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Vídeos', 'error');
                    });
            },
            setVideos: function () {
                const self = this;
                let videos = self.selected;

                $('#videos').find(':selected').each(function () {
                    videos.push(self.videos[$(this).val()]);
                });

                self.selected = videos;
                self.order = true;
            },
            save: function () {
                const self = this;

                postReorder(self, self.selected, "sort/video", self.getVideosArray);
            },
            remove: function (video, index) {
                const self = this;
                const api = self.$store.state.api + 'video/' + video.id;

                let array = [];
                $.each(self.selected, function (key, value) {
                    if (index !== key) {
                        array.push(value);
                    }
                });

                self.$http
                    .put(api, {
                        sort_by: null
                    })
                    .then((response) => {
                        self.selected = array;
                    });
            },
            back: function () {
                window.location.reload();
            }
        },
        mounted: function () {
            this.getVideos();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/VideoOrder/Index.vue